import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import DefaultInput from "../../components/form/DefaultInput";
import { LoginResponseDocumentation, userRoles } from "../../types/enums";
import { Button, Divider, message, Modal, Select, SelectProps } from "antd";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import classes from "./index.module.css";
import useLang from "../../hooks/useLang";
import DefaultSwitch from "../../components/form/DefaultSwitch";
import DefaultPhoneInput from "../../components/form/DefaultPhoneInput";
import DefaultSelect from "../../components/form/DefaultSelect";
import DefaultPasswordInput from "../../components/form/DefaultPasswordInput";
import {
	CheckCircleTwoTone,
	CloseCircleTwoTone,
	UploadOutlined,
} from "@ant-design/icons";
import { getUserIdFromToken } from "../../utils/Auth";
import { usernamePasswordValidate } from "../../types/UsernamePasswordValidate";
import { fetchZones, getConfigurationValue } from "../../lib/OptionListApi";
import RegisterForm from "../Login/RegisterForm";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/authSlice";
import Buttons from "../../components/form/Buttons";
import PlaceAutocomplete from "../../components/GoogleMaps/PlaceAutocomplete";
import { CONFIG } from "../../config";
import AddressSelect from "../../components/form/AddressSelect";

interface IUserInsertData {
	[name: string]: any;
}

const UserDocumentsRestore: FC = () => {
	const dispatch = useDispatch();
	const { strings } = useLang("userDocumentRestore");
	const navigate = useNavigate();

	const [firstLastName, setFirstLastName] = useState<string>("");
	const [email, setEmail] = useState<string>("");
	const [username, setUsername] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [confirmPassword, setConfirmPassword] = useState<string>("");
	const [phone, setPhone] = useState<string>("");
	const [address, setAddress] = useState<string>("");
	const [identificationNumber, setIdentificationNumber] = useState<
		string | undefined
	>();
	const [country, setCountry] = useState<string | undefined>();
	const [city, setCity] = useState<string | undefined>();
	const [temporaryLinkValidationData, setTemporaryLinkValidationData] =
		useState<any>([]);
	const [countryDropDown, setCountryDropDown] = useState<any>([]);
	const [cityDropDown, setCityDropDown] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);
	const [countryLabel, setCountryLabel] = useState<string>("xk");
	const [cityLabel, setCityLabel] = useState<string | undefined>("");
	const [apiLatitude, setApiLatitude] = useState<number | null>();
	const [apiLongitude, setApiLongitude] = useState<number | null>();
	const [sectionId, setSectionId] = useState<number | null>(null);
	// const [finalAddress, setFinalAddress] = useState<string>("");
	const [checkbox, setCheckbox] = useState<boolean>(false);
	const [businessPhoneNumber, setBusinessPhoneNumber] = useState<string>("");
	const [businessNumber, setBusinessNumber] = useState<string>("");
	const [businessName, setBusinessName] = useState<string>("");
	const [error, setError] = useState<boolean>(false);
	const [cash, setCash] = useState<boolean>(true);
	const [bank, setBank] = useState<boolean>(false);
	const [adressPosition, setAddressPosition] = useState<any>(null);
	const markerRef = useRef(null);
	const [position, setPosition] = useState<any>(null);
	const [phoneCode, setPhoneCode] = useState<string>("");
	const [phonePrefix, setPhonePrefix] = useState<string>("");
	const [oldUserId, setOldUserId] = useState<any | undefined>();
	const [openPhoneCodeConfirmationModal, setOpenPhoneCodeConfirmationModal] =
		useState<boolean>(false);
	const [personalIdLength, setPersonalIdLength] = useState<any>();
	const [allSections, setAllSections] = useState<any>([]);

	const [data, setData] = useState<SelectProps["options"]>([]);

	const setInputStates = (data: any) => {
		setFirstLastName(data.firstLastName);
		setEmail(data?.email);
		setUsername(data?.username);
	};
	const fetchConfiguration = useCallback(async () => {
		const numberPrefix = await getConfigurationValue(1);
		const identificationNumberLength = await getConfigurationValue(3);
		setPersonalIdLength(identificationNumberLength);
		setPhonePrefix(numberPrefix);
	}, []);

	const fetchUnRegisteredOldUsers = useCallback(async (userId: any) => {
		try {
			const response = await api.get("User/fetch-old-user-details", {
				params: { userId: userId },
			});
			if (response.status === 200) {
				setInputStates(response?.data);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	useEffect(() => {
		const userId = getUserIdFromToken();
		setOldUserId(userId);
		fetchUnRegisteredOldUsers(userId);
		fetchConfiguration();
		setCountriesAndCities();
	}, [fetchConfiguration, fetchUnRegisteredOldUsers]);

	const setCountriesAndCities = async () => {
		const zones = await fetchZones();
		const countryId = await getConfigurationValue(2);
		if (zones) {
			const countries = zones
				.filter(
					(item: any) => item.levelId === 1 && item.id == countryId
				)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCountryDropDown(countries);
			const filteredCities = zones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCityDropDown(filteredCities);
			const cities = zones?.filter((item: any) => item.levelId === 2);
			setCities(cities);
			const sections = zones?.filter((item: any) => item.levelId === 3);
			setAllSections(sections);
		}
	};

	const fetchGeoData = useCallback(async (latitude: any, longitude: any) => {
		try {
			const response = await api.get("External/get-geo-data", {
				params: {
					lng: longitude,
					lat: latitude,
					category: CONFIG?.zoneMbledhs ?? "",
				},
			});
			if (response.status === 200) {
				const result = response?.data;
				const section = Number(result.geofences[0]?.name);
				setSectionId(section);
				// setFinalAddress(result.result);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	const handleSearch = (address: any) => {
		if (!country || !city) {
			toast.error("Ju lutem zgjedhni shtetin dhe qytetin");
			setAddress("");
			(autocompleteRef as any).current.handleClear();
			return;
		}
	};

	const fetchAddresesSearch = (address: any) => {
		const params = {
			q: address || "",
			limit: "5",
			lang: "en",
		};
		const queryString = new URLSearchParams(params).toString();
		const requestOptions: RequestInit = {
			method: "GET",
			redirect: "follow",
		};
		fetch(`https://photon.komoot.io/api/?${queryString}`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				const formattedData = result.features.map((feature: any) => ({
					value: feature.properties.osm_id,
					label: feature.properties.name,
					lat: feature.geometry.coordinates[1],
					lon: feature.geometry.coordinates[0],
				}));
				setData(formattedData);
			})
			.catch((err) => console.log("err: ", err));
	};

	const handleChange = (address: any) => {
		const selectedLocation = address;
		if (selectedLocation) {
			const lat = selectedLocation.lat;
			const lng = selectedLocation.lng;
			setAddressPosition([lat, lng]);
			setPosition([lat, lng]);
			setApiLatitude(lat);
			setApiLongitude(lng);
			fetchGeoData(lat, lng);
			setAddress(selectedLocation.label ?? "");
		}
	};

	const phoneNumberChange = (e: any) => {
		const phoneNumber = e.target.value;
		setPhone(phoneNumber);
	};

	const handleConfirmPasswordChange = (e: any) => {
		setConfirmPassword(e.target.value);
		if (password === e.target.value) {
			setError(false);
		}
	};

	const handleBlur = useCallback(() => {
		if (password !== confirmPassword) {
			message.error("Fjalëkalimet nuk përputhen.");
			setError(true);
			return true;
		} else {
			setError(false);
		}
	}, [confirmPassword, password]);

	const onCountrySelect = (e: any) => {
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setCountry(e);
		if (e === 1) {
			setCountryLabel("xk");
		} else if (e === 2) {
			setCountryLabel("al");
		} else if (e === 3) {
			setCountryLabel("mk");
		}
		setCity("");
		setCityLabel("");
		setAddress("");
		(autocompleteRef as any).current.handleClear();
		// setFinalAddress("");
		// setData([]);
	};

	const onCitySelect = (value: any) => {
		if (value?.value) {
			const id = value.value;
			setCity(id);
			setCityLabel(value?.label);
			setAddress("");
			(autocompleteRef as any).current.handleClear();
			// setData([]);
		} else {
			setCity("");
			setCityLabel("");
			setAddress("");
			(autocompleteRef as any).current.handleClear();
			// setData([]);
		}
	};
	const clearCitySelection = () => {
		setCity("");
		setCityLabel("");
		setAddress("");
		(autocompleteRef as any).current.handleClear();
		// setFinalAddress("");
		setSectionId(0);
	};
	const changeSwitch = () => {
		setCash((prevState) => !prevState);
		setBank((prevState) => !prevState);
	};
	const validateInsertedData = (data: any) => {
		const {
			firstName,
			lastName,
			phone,
			address,
			username,
			password,
			identificationNumber,
			sectionId,
		} = data;

		if (!firstName) {
			toast.error("Emri është i detyrueshëm");
			return false;
		}
		if (!lastName) {
			toast.error("Mbiemri është i detyrueshëm");
			return false;
		}
		if (!phone) {
			toast.error("Numri i telefonit është i detyrueshëm");
			return false;
		}
		if (!address) {
			toast.error("Adresa është e detyrueshme");
			return false;
		}
		if (!username) {
			toast.error("Username është i detyrueshëm");
			return false;
		}
		if (!password) {
			toast.error("Fjalekalimi është i detyrueshëm");
			return false;
		}
		if (!identificationNumber) {
			toast.error("Nr i leternjoftimit është i detyrueshëm.");
			return false;
		}
		if (identificationNumber.length !== parseInt(personalIdLength)) {
			toast.error(
				`Nr i leternjoftimi duhet te kete ${personalIdLength} karaktere`
			);
			return false;
		}
		if (!sectionId) {
			toast.error("Error zona");
			return false;
		}

		return true;
	};

	const validateUsernameAndEmail = async () => {
		try {
			const response = await api.get("User/validate-username-email", {
				params: { username: username, email: email ? email : null },
			});
			if (response.status === 200) {
				const result = response.data;
				if (result.message === "Valid") {
					return true;
				} else {
					toast.error(`${result.message}`);
					return false;
					// Show an error message to the user
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const checkPhoneNumber = async () => {
		if (!phone) {
			toast.error(
				"Ju lutem shenoni Kodin te cilin e keni pranuar ne telefon"
			);
			return;
		}
		try {
			const response = await api.get("OTP/select-otp", {
				params: { phoneNumber: phone },
			});
			if (response.status === 200) {
				return response?.data;
			}
		} catch (error) {
			console.log(error);
		}
	};

	const register = async () => {
		const fullNameArray = firstLastName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		// const fullAddress = finalAddress.split("/");
		// const splitAddress = fullAddress[0] || "";

		const otpNumber = {
			numbers: [phone],
		};

		const validation = usernamePasswordValidate(username, password);

		if (!validation.valid) {
			toast.error(validation.message);
			return;
		}

		if (!phone.startsWith(phonePrefix) && phone.length !== 11) {
			toast.error(
				`Numri i telefonit duhet te filloje me ${phonePrefix} dhe te kete 11 numra`
			);
			return;
		}

		if (businessName.length > 0 && !businessNumber) {
			toast.error("Numri i biznesit eshte i detyrueshem");
			return;
		}

		const existingSection = allSections?.some(
			(item: any) => sectionId !== null && item.id === sectionId
		);

		if (!existingSection) {
			toast.error(
				"Kjo Zone nuk eshte e regjistruar! Ju lutem kontaktoni Postman"
			);
			return;
		}
		const isUnique = await validateUsernameAndEmail();
		if (!isUnique) {
			return false;
		}
		const data = {
			firstName: firstName,
			lastName: lastName,
			phone: phone,
			address: address,
			username: username,
			email: email,
			password: password,
			userRoleId: userRoles.CLIENT,
			identificationNumber: identificationNumber,
			sectionId: sectionId,
			longitude: apiLongitude?.toString(),
			latitude: apiLatitude?.toString(),
			packagePriceIncudesTaxes: false,
			bankPackageTransportPayment: bank,
			cashPackageTransportPayment: cash,
			businessName: businessName,
			businessNumber: businessNumber,
			businessNr: businessPhoneNumber,
			status: false,
			approved: false,
		};
		if (validateInsertedData(data)) {
			const resendOtp = await checkPhoneNumber();
			if (!resendOtp) {
				try {
					const response = await api.post(
						"OTP/insert-otp",
						otpNumber
					);
					if (response.data.success === true) {
						setOpenPhoneCodeConfirmationModal(true);
					}
				} catch (error) {
					console.log(error);
					return;
				}
			} else {
				setOpenPhoneCodeConfirmationModal(true);
			}
		} else {
			return;
		}
		return;
	};

	const logOutAndNavigate = useCallback(() => {
		// Log out here even when the API cannot be reached: the user asked to leave, and a failed
		// session refresh no longer logs them out on its own.
		api.post("user/logout")
			.catch(() => undefined)
			.then(() => {
				dispatch(logout());
				localStorage.removeItem("token");
				navigate("/login");
			});
	}, [dispatch, navigate]);

	const checkPhoneCode = async () => {
		if (!phoneCode) {
			toast.error(
				"Ju lutem shenoni Kodin te cilin e keni pranuar ne telefon"
			);
			return;
		}
		try {
			const response = await api.get("OTP/select-otp", {
				params: { code: phoneCode, phoneNumber: phone },
			});
			if (response.status === 200 && response?.data === true) {
				clearePhoneCodeModalState();
				registerClient();
			} else if (response?.data === false) {
				toast.error("Gabim");
				clearePhoneCodeModalState();
				return false;
			}
		} catch (error) {
			console.log(error);
		}
	};

	const clearePhoneCodeModalState = () => {
		setOpenPhoneCodeConfirmationModal(false);
		setPhoneCode("");
	};
	let autocompleteRef = useRef<any>();
	const registerClient = async () => {
		const fullNameArray = firstLastName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		// const fullAddress = finalAddress.split("/");
		// const splitAddress = fullAddress[0] || "";

		const formData = new FormData();

		const data: IUserInsertData = {
			firstName: firstName,
			lastName: lastName,
			phone: phone,
			address: address,
			username: username,
			email: email,
			password: password,
			userRoleId: userRoles.CLIENT,
			identificationNumber: identificationNumber,
			sectionId: sectionId,
			longitude: apiLongitude?.toString(),
			latitude: apiLatitude?.toString(),
			packagePriceIncudesTaxes: false,
			bankPackageTransportPayment: bank,
			cashPackageTransportPayment: cash,
			businessName: businessName,
			businessNumber: businessNumber,
			businessNr: businessPhoneNumber,
			status: true,
			approved: true,
			code: phoneCode,
			oldUserId: oldUserId,
		};

		if (!phone.startsWith(phonePrefix) && phone.length !== 11) {
			toast.error(`Numri i telefonit duhet te filloje me ${phonePrefix}`);
			return;
		}
		for (const key in data) {
			formData.append(key, data?.[key]?.toString() ?? "");
		}
		try {
			const response = await api.post(
				"User/main-register-test",
				formData
			);
			if (response.status === 200) {
				toast.success("Aplikimi u krye me sukses!");
				// setSubmited(true);
				logOutAndNavigate();
				return;
			} else {
				toast.error(
					"Një gabim ndodhi gjatë aplikimit tuaj. Ju lutemi provoni përsëri më vonë"
				);
			}
		} catch (error: any) {
			toast.error(error?.response?.data);
		}
	};

	return (
		<>
			<div className={classes.main}>
				<p className="registerTitle">
					Ri-konfirmo dhe ploteso te dhenat
				</p>
				<p className="text-rose-600">
					Ju lutem keni kujdes, pas vendosjes se te dhenave ne forme
					dhe ne rast te ndryshimit te tyre duhet te kyqeni vetem me
					Username dhe Fjalekalim te cilin e vendosni tani!
				</p>
				<div className={classes.firstContainer}>
					{/* <div className="flex flex-wrap gap-4 "> */}
					<div className={classes.registerInputs}>
						<DefaultInput
							className={classes.registerInput}
							label={strings?.inputs.firstLastName.label}
							placeholder={
								strings?.inputs.firstLastName.placeholder
							}
							value={firstLastName}
							onChange={(e) => setFirstLastName(e.target.value)}
						/>
						<DefaultInput
							className={classes.registerInput}
							label={strings?.inputs.phone.label}
							placeholder={strings?.inputs.phone.placeholder}
							value={phone}
							onChange={(e) => phoneNumberChange(e)}
						/>
						<DefaultInput
							className={classes.registerInput}
							label={strings?.inputs.identificationNumber.label}
							value={identificationNumber}
							onChange={(e) =>
								setIdentificationNumber(e.target.value)
							}
							placeholder={
								strings?.inputs.identificationNumber.placeholder
							}
						/>

						<DefaultInput
							className={classes.registerInput}
							label={strings?.inputs.username.label}
							placeholder={strings?.inputs.username.placeholder}
							value={username}
							onChange={(e) => setUsername(e.target.value)}
						/>
						<DefaultInput
							className={classes.registerInput}
							label={strings?.inputs.email.label}
							placeholder={strings?.inputs.email.placeholder}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
						<DefaultPasswordInput
							className={classes.registerInput}
							label={strings?.inputs.password.label}
							value={password}
							placeholder={strings?.inputs.password.placeholder}
							onChange={(e) => setPassword(e.target.value)}
							onBlur={handleBlur}
							allowClear={true}
						/>
						<DefaultInput
							label={strings?.inputs.confirmPassword.label}
							className={classes.registerInput}
							value={confirmPassword}
							onChange={handleConfirmPasswordChange}
							onBlur={handleBlur}
							placeholder={
								strings?.inputs.confirmPassword.placeholder
							}
							status={error ? "error" : ""}
							type="password"
							suffix={
								error ? (
									<CloseCircleTwoTone twoToneColor="#ff4d4f" />
								) : (
									<CheckCircleTwoTone twoToneColor="#52c41a" />
								)
							}
							allowClear={true}
						/>
						<DefaultSelect
							className={classes.registerInput}
							onChange={onCountrySelect}
							value={country}
							placeholder={strings?.inputs.country.placeholder}
							label={strings?.inputs.country.label}
							flexDirection="col"
							alignCenter="start"
							options={countryDropDown}
							allowClear
						/>
						<DefaultSelect
							className={classes.registerInput}
							placeholder={strings?.inputs.city.placeholder}
							value={city}
							onChange={onCitySelect}
							label={strings?.inputs.city.label}
							flexDirection="col"
							alignCenter="start"
							options={cityDropDown}
							allowClear
							onClear={clearCitySelection}
							labelInValue={true}
						/>
						<div className="flex flex-col items-start ">
							<label className="w-42 -mt-1">
								{strings?.inputs.address.label}
							</label>
							<PlaceAutocomplete
								onAddressChange={handleChange}
								ref={autocompleteRef}
								country={countryLabel}
							/>
							{/* <AddressSelect
								onAddressChange={handleChange}
								country={countryLabel}
								selectedAddress={address}
								city={cityLabel}
							/> */}
							{/* <Select
								className={classes.registerInput}
								showSearch
								value={address}
								placeholder={
									strings?.inputs.address.placeholder
								}
								defaultActiveFirstOption={false}
								suffixIcon={null}
								filterOption={false}
								onSearch={handleSearch}
								onChange={handleChange}
								notFoundContent={null}
								options={data?.map((item) => ({
									value: item.value,
									label: item.label,
								}))}
							/> */}
						</div>
						<DefaultInput
							className={classes.registerInput}
							label={strings?.inputs.businessName.label}
							placeholder={
								strings?.inputs.businessName.placeholder
							}
							value={businessName}
							onChange={(e) => setBusinessName(e.target.value)}
						/>
						<DefaultInput
							className={classes.registerInput}
							label={strings?.inputs.businessNumber.label}
							placeholder={
								strings?.inputs.businessNumber.placeholder
							}
							value={businessNumber}
							onChange={(e) => setBusinessNumber(e.target.value)}
						/>
						<DefaultPhoneInput
							className="registerInputPhone"
							label={strings?.inputs.businessPhone.label}
							placeholder={
								strings?.inputs.businessPhone.placeholder
							}
							initialPhoneNumber={businessPhoneNumber}
							onPhoneNumberChange={(v) =>
								setBusinessPhoneNumber(v)
							}
						/>
						<div className="flex flex-col items-start justify-start w-auto gap-2  gap-4 ml-4 pagesat">
							<p>{strings?.switches.postalServicePayment}</p>
							<div className="flex flex-row justify-around gap-2">
								<DefaultSwitch
									label={strings?.switches.cash}
									checked={cash}
									onChange={changeSwitch}
								/>
								<DefaultSwitch
									label={strings?.switches.bank}
									checked={bank}
									onChange={changeSwitch}
								/>
							</div>
						</div>
					</div>
					<div className="lastDiv">
						{/* <Button
							className={classes.registerButton}
							onClick={registerClient}
						>
							Konfirmo
						</Button> */}
						<Buttons
							button1Text="Mbyll"
							button2Text="Konfirmo"
							onButton1Click={logOutAndNavigate}
							onButton2Click={register}
						/>
					</div>
				</div>
			</div>
			<Modal
				open={openPhoneCodeConfirmationModal}
				title={strings?.phoneConfirmation?.title}
				onCancel={clearePhoneCodeModalState}
				footer={() => (
					<div className="flex  items-center justify-center">
						<Button
							className="registerButton"
							onClick={checkPhoneCode}
						>
							{strings?.phoneConfirmation.confirmButton}
						</Button>
					</div>
				)}
			>
				<Divider />
				<div className="flex  items-start justify-start pb-6">
					<p className="text-base antialiased">
						{strings?.phoneConfirmation.subtitle} <b>+{phone}</b>
					</p>
				</div>
				<div className="flex flex-col gap-4 items-center justify-center">
					<DefaultInput
						label={strings?.phoneConfirmation.phoneCode}
						value={phoneCode}
						className={classes.registerInput}
						onChange={(e) => setPhoneCode(e.target.value)}
					/>
				</div>
			</Modal>
		</>
	);
};

export default UserDocumentsRestore;
